import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiClient } from "../../../api/apiServices";

export default function FundingSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const verifyPayment = async () => {
      const reference = searchParams.get("reference");

      if (!reference) {
        navigate("/");
        return;
      }

      try {
        await apiClient.get(`/funding/paystack/verify/${reference}`);

        // success → go home
        navigate("/");
      } catch (error) {
        console.error("Verification failed:", error);
        navigate("/");
      }
    };

    verifyPayment();
  }, [navigate, searchParams]);

  return (
    <div className="flex items-center justify-center h-screen">
      <p className="text-lg font-semibold">Verifying payment...</p>
    </div>
  );
}